import HamburgerSvg from '@/stories/assets/common/hamburger.inline.svg'

export default function Hamburger() {
  return (
    <div className="w-5 cursor-pointer" role="button" title="menu">
      <HamburgerSvg />
    </div>
  )
}
